import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import config from '../../../../configuration/config';

const routesQueue = {};
const cache = {

    get(route){
        return routesQueue[route] || [];
    },
    set(route, val){
        routesQueue[route] = [...this.get(route), val];
    },
    removeEntry(route) {

        const current = [...this.get(route)];
        current.shift();

        routesQueue[route] = current;
    }
};

class RequestService {

    initialize(context) {

        this.context = context;
    }

    post(route, payload){

        cache.set(route, payload);

        return postRequest(route, payload, this.context).then((result) => {

            const currentQueue = cache.get(route);
            result.accepted = currentQueue.length === 1;

            cache.removeEntry(route);
            return result;
        });
    }
}

const postRequest = async(route, payload, context) => {
    const url = `${config.api_prefix}/${route}`;

    try {
        const { data } = await axios.post(url, { ...context, ...payload });

        return data;
    } catch (err) {
        logger.warn({
            message:`Failed on Search perseus Request service | url: ${url}`,
            error: err
        });

        throw err;
    }
};

export default new RequestService();
